export const en = {
    'to-main-page': 'To the main page',
    'edit-field-placeholder': 'Enter or it will be generated automatically',
    'edit-field-save': 'Save',
    'edit-field-cancel': 'Cancel',
    'edit-button-title': 'Edit call name',
}
